import { RootState } from "RootReducer";

export const selectDemoMode = (state: RootState) => state.admin?.demoMode ?? false;
